<div class="organization-contacts crm-page">
  @if (isLoading) {
    <div class="crm-page__overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ "MESSAGES.LOADING" | translate }}</span>
      </div>
    </div>
  }

  <div class="crm-page__toolbar">
    <div class="organization-contacts__toolbar-spacer"></div>

    <div class="organization-contacts__actions">
      <button
        type="button"
        #contactPopover="ngbPopover"
        class="overview-btn overview-btn-primary"
        [ngbTooltip]="'BUTTONS.ADD_CONTACT' | translate"
        [ngbPopover]="addContactForm"
        popoverClass="popover-lg project-files-rename-popover"
        autoClose="outside"
        placement="bottom-end"
      >
        + {{ "BUTTONS.ADD_CONTACT" | translate }}
      </button>
    </div>
  </div>

  <ng-template #addContactForm>
    <div
      [formGroup]="newOrganizationContactForm.form"
      class="files-rename-form organization-contacts__popover-form"
    >
      <app-search
        formControlName="newContactId"
        [items]="(companyContacts$ | async)!"
        [filterFn]="contactFullNameFilter"
        [formatter]="contactFormatter"
        [compareFn]="contactCompareFn"
        [placeholderText]="'INPUTS.CONTACT' | translate"
        [errorMessage]="'ERRORS.INCORRECT_SELECTED_CONTACT' | translate"
        [resultTemplate]="customTemplate"
        customClass="files-rename-input input-sm organization-contacts__popover-search"
      >
        <ng-template #customTemplate let-r="result" let-t="term">
          <ngb-highlight
            class="organization-contacts__search-highlight"
            highlightClass="hover-highlight"
            [result]="r?.fullName"
            [term]="t"
          ></ngb-highlight>
          <div>{{ r?.phoneNumber }}</div>
        </ng-template>
      </app-search>

      <button
        type="button"
        class="files-rename-action files-rename-action--confirm"
        [disabled]="newOrganizationContactForm.form.invalid"
        (click)="addContact(contactPopover)"
      >
        {{ "BUTTONS.ADD" | translate }}
      </button>
    </div>

    @if (canCreateContacts$ | async) {
      <button
        class="organization-contacts__popover-secondary"
        type="button"
        (click)="openCreateContactModal(contactPopover)"
      >
        + {{ "BUTTONS.ADD_CONTACT" | translate }}
      </button>
    }
  </ng-template>

  @if (organizationContacts$ | async; as contacts) {
    @if (!contacts.length) {
      <app-card-shell class="crm-page__empty-card" padding="none">
        <div class="crm-page__empty-state">
          {{ "MESSAGES.EMPTY_LIST" | translate: { param: ("INPUTS.CONTACT" | translate) } }}
        </div>
      </app-card-shell>
    } @else {
      <app-card-shell class="crm-page__list-card" padding="none">
        <div class="crm-table__desktop">
          <div class="crm-table__scroller">
            <table class="crm-table__table organization-contacts__table">
              <thead>
                <tr class="crm-table__header-row">
                  <th class="crm-table__header-cell">{{ "TABLE_HEADERS.FULL_NAME" | translate }}</th>
                  <th class="crm-table__header-cell">{{ "TABLE_HEADERS.EMAIL" | translate }}</th>
                  <th class="crm-table__header-cell">{{ "TABLE_HEADERS.PHONE_NUMBER" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (contact of contacts; track contact.id) {
                  <tr class="crm-table__row">
                    <td class="crm-table__cell crm-table__cell--title">
                      <a [routerLink]="['../../', 'contacts', contact.id]">
                        {{ contact.fullName }}
                      </a>
                    </td>
                    <td class="crm-table__cell">{{ contact.email || "-" }}</td>
                    <td class="crm-table__cell">{{ contact.phoneNumber || "-" }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </app-card-shell>

      <section class="crm-table__mobile-section">
        <div class="crm-table__mobile-list">
          @for (contact of displayedContacts$ | async; track contact.id) {
            <article class="crm-mobile-card">
              <div class="crm-mobile-card__header">
                <div class="crm-mobile-card__title-wrap">
                  <div class="crm-mobile-card__title-block">
                    <a
                      [routerLink]="['../../', 'contacts', contact.id]"
                      class="crm-mobile-card__title"
                    >
                      {{ contact.fullName }}
                    </a>
                  </div>
                </div>
              </div>

              <div class="crm-mobile-card__grid">
                <div class="crm-mobile-card__field">
                  <p class="crm-mobile-card__label">
                    {{ "TABLE_HEADERS.EMAIL" | translate }}
                  </p>
                  <p class="crm-mobile-card__value">
                    {{ contact.email || "-" }}
                  </p>
                </div>

                <div class="crm-mobile-card__field">
                  <p class="crm-mobile-card__label">
                    {{ "TABLE_HEADERS.PHONE_NUMBER" | translate }}
                  </p>
                  <p class="crm-mobile-card__value">
                    {{ contact.phoneNumber || "-" }}
                  </p>
                </div>
              </div>
            </article>
          }
        </div>

        @if (contacts.length > 3) {
          <button class="organization-contacts__toggle" type="button" (click)="toggleContacts()">
            {{ (showAll$.value ? "BUTTONS.SHOW_LESS" : "BUTTONS.SHOW_MORE") | translate }}
          </button>
        }
      </section>
    }
  }

</div>
